import { Button, Card } from 'antd';
import React from 'react';
import { OrderResponse, OrderSourceEnum } from '../../models/PatientModels';
import { Link, useParams } from 'react-router-dom';
import RoundedButton from '../RoundedButton';

interface Props {
    orders?: OrderResponse[];
}

const PatientApproveMedicationsCard: React.FC<Props> = ({ orders = [] }) => {
    const { id: patientId = '' } = useParams();

    const getOrderSourceLabel = (source: number): string => {
        return OrderSourceEnum[source] ?? 'Unknown Source';
    };

    return (
        <div
            className="d-grid w-100 px-4"
            style={{
                gridTemplateColumns: 'repeat(auto-fill, minmax(22em, 1fr))',
                gap: '1em',
            }}
        >
            {orders.map((order) => (
                <Card
                    key={order.id}
                    className="shadow-sm bg-body mt-4 d-flex flex-column justify-content-between rounded fw-bold text-light-gray"
                    headStyle={{
                        padding: '0 1em',
                    }}
                    title={order.drugName}
                >
                    <div>
                        <div className="d-flex py-1 fw-normal p-1">
                            <span className="hcrx-order-gray">
                                Source:&nbsp;
                            </span>
                            <span className="fw-bold text-medium-blue">
                                {getOrderSourceLabel(order.source)}
                            </span>
                        </div>

                        <div
                            className="d-flex flex-column lh-sm mt-lg-4 p-1"
                            style={{ fontWeight: 300 }}
                        >
                            <div className="text-black-50">Drug Format</div>
                            <div className="fs-6">{order.drugFormat}</div>
                        </div>
                    </div>
                    <div
                        className="mt-4"
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <Link
                            to={`/patient/${patientId}/add-approve-medication/${order.scriptSureOrderId}/${order.id}`}
                        >
                            <RoundedButton
                                className={
                                    'fw-semibold bg-light-blue text-white fw-semibold'
                                }
                            >
                                Submit
                            </RoundedButton>
                        </Link>
                    </div>
                </Card>
            ))}
        </div>
    );
};

export default PatientApproveMedicationsCard;
